import { GetPlayerSourceParams, GetEmbedURLByProviderParams } from './types'

import LanguageHelper from 'common/helpers/language'
import Settings from 'common/helpers/settings/.'
import { Provider } from 'modules/transmission/types'
import VimeoHelper from '../vimeo'
import YoutubeHelper from '../youtube'
import { EMBED_PARAMS } from '../../constants'

export default class PlayerHelper {
  static getPlayerEmbedURL = ({
    mediaCode,
    embedUrl,
    leadCode,
    playerJwt,
    applicationCode,
    userCode
  }: GetPlayerSourceParams): string => {
    let params = [
      `locale=${LanguageHelper.currentLanguage}`,
      ...(EMBED_PARAMS[Provider.HOTMART] || [])
    ]

    if (playerJwt && applicationCode && userCode) {
      params = [
        ...params,
        `jwtToken=${playerJwt}`,
        `applicationCode=${applicationCode}`,
        `userCode=${userCode}`
      ]
    }

    const playerEmbed = embedUrl || Settings.app.playerEmbed

    leadCode && params.push(`user=${leadCode}`)

    return `${playerEmbed}/embed/${mediaCode}?${params.join('&')}`
  }

  static getEmbedURLByProvider = ({
    url,
    provider,
    ...params
  }: GetEmbedURLByProviderParams): string => {
    const methodByProvider: { [provider in Provider]: () => string } = {
      [Provider.HOTMART]: () => PlayerHelper.getPlayerEmbedURL(params),
      [Provider.VIMEO]: () => VimeoHelper.getEmbedURL(url),
      [Provider.YOUTUBE_HOTMART]: () => YoutubeHelper.getEmbedURL(url),
      [Provider.YOUTUBE]: () => YoutubeHelper.getEmbedURL(url),
      [Provider.MUX_STUDIO_HOTMART]: () => PlayerHelper.getPlayerEmbedURL(params)
    }

    return methodByProvider[provider]()
  }
}
